export abstract class LanguageSelection {
  abstract get language(): string;
}
